const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  // Preserve all current filter parameters from the URL
  // This ensures that when loading more products, all active filters are maintained
  const currentUrlParams = new URLSearchParams(window.location.search);
  const nextUrlObj = new URL(nextUrl, window.location.origin);
  const nextUrlParams = new URLSearchParams(nextUrlObj.search);
  
  // Copy all filter parameters from current URL to the next URL
  currentUrlParams.forEach((value, key) => {
    if (key.startsWith('filter.')) {
      // Preserve all filter parameters (style, hardware, length, material, etc.)
      if (!nextUrlParams.has(key) || nextUrlParams.get(key) !== value) {
        // If the parameter has multiple values, add all of them
        const allValues = currentUrlParams.getAll(key);
        nextUrlParams.delete(key); // Remove existing to avoid duplicates
        allValues.forEach(val => nextUrlParams.append(key, val));
      }
    }
  });
  
  // Reconstruct the URL with all filter parameters
  nextUrlObj.search = nextUrlParams.toString();
  nextUrl = nextUrlObj.pathname + (nextUrlParams.toString() ? '?' + nextUrlParams.toString() : '');

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      // Store current product count before adding new products
      const productGrid = document.getElementById('product-grid');
      const currentCardCount = productGrid ? productGrid.querySelectorAll('.collection-product-card').length : 0;
      
      // Append new products
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      
      // Immediately hide newly added products to prevent flashing
      // Check if any filters are active (Style, Hardware, Length, Material, etc.)
      const urlParams = new URLSearchParams(window.location.search);
      const hasAnyFilter = Array.from(urlParams.keys()).some(key => 
        key.startsWith('filter.p.collection.') || key.startsWith('filter.v.option.')
      );
      
      if (hasAnyFilter && productGrid) {
        // Get all cards after appending
        const allCards = productGrid.querySelectorAll('.collection-product-card');
        // Hide only the newly added cards (those beyond the previous count)
        for (let i = currentCardCount; i < allCards.length; i++) {
          allCards[i].style.display = 'none';
          allCards[i].setAttribute('data-filtered-out', 'true');
        }
      }
      
      colorSwatches();
      
      // Filter newly loaded products by style and hardware collections if filters are active
      // Use requestAnimationFrame to ensure DOM is fully updated and attributes are set
      requestAnimationFrame(() => {
        if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.filterProductsByCollections) {
          FacetFiltersForm.filterProductsByCollections();
        }
      });
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();